import { FileError, FileRejection } from 'react-dropzone';

import { FileExtension, MAX_SIZE_OF_FILE } from '@/common/constants';
import { FileErrorCode } from '@/components/elements/DropScan/dropScan.types';
import { getFileExtension } from '@/utils/modifiers/getFileExtension';

import { isValidFilesSignature } from './isValidFilesSignature';

interface Props {
  acceptedFiles: File[];
  fileRejections: FileRejection[];
  onFileUploadError?: (error?: FileError) => void,
}

const validateFiles = async ({ acceptedFiles, fileRejections, onFileUploadError }: Props) => {
  const errors = fileRejections.map((fileRejection) => fileRejection.errors).flat();
  const typeError = errors.find((fileError) => fileError.code === FileErrorCode.FileInvalidType);
  const extensionError = acceptedFiles.find((file) => {
    const extension = getFileExtension(file);
    return !extension || !Object.values(FileExtension).includes(`.${extension}` as FileExtension);
  });


  if (typeError || extensionError) {
    onFileUploadError?.({ code: FileErrorCode.FileInvalidType, message: '' });
    return true;
  }

  if (fileRejections.some((item) => item.file.size >= MAX_SIZE_OF_FILE)) {
    onFileUploadError?.({ code: FileErrorCode.FileTooLarge, message: '' });
    return true;
  }

  const isValidSignature = await isValidFilesSignature(acceptedFiles);
  if (!isValidSignature) {
    onFileUploadError?.({ code: FileErrorCode.InvalidFile, message: '' });
    return true;
  }

  return false;
};

export default validateFiles;
